import i18next from 'i18next'
import {PaymentMethodItem} from '@/stores/payment-methods/PaymentMethods/models'
import {PaymentMethodType} from '@/constants'
import {getPaymentMethodDetailsRoute, getRouterStore} from '@/router/utils'

export const paymentMethods: () => PaymentMethodItem[] = () => [
    {
        link: getPaymentMethodDetailsRoute(PaymentMethodType.applepay),
        title: i18next.t('enums:paymentMethodType.applepay'),
        linkText: i18next.t('PaymentMethods.viewDetails'),
        onClick: () =>
            getRouterStore().push(getPaymentMethodDetailsRoute(PaymentMethodType.applepay)),
        type: PaymentMethodType.applepay
    },
    {
        link: getPaymentMethodDetailsRoute(PaymentMethodType.googlepay),
        title: i18next.t('enums:paymentMethodType.googlepay'),
        linkText: i18next.t('PaymentMethods.viewDetails'),
        onClick: () =>
            getRouterStore().push(getPaymentMethodDetailsRoute(PaymentMethodType.googlepay)),
        type: PaymentMethodType.googlepay
    },
    {
        link: getPaymentMethodDetailsRoute(PaymentMethodType.paypal),
        title: i18next.t('enums:paymentMethodType.paypal'),
        linkText: i18next.t('PaymentMethods.viewDetails'),
        onClick: () =>
            getRouterStore().push(getPaymentMethodDetailsRoute(PaymentMethodType.paypal)),
        type: PaymentMethodType.paypal
    },
    {
        link: getPaymentMethodDetailsRoute(PaymentMethodType.klarna),
        title: i18next.t('enums:paymentMethodType.klarna'),
        linkText: i18next.t('PaymentMethods.viewDetails'),
        onClick: () =>
            getRouterStore().push(getPaymentMethodDetailsRoute(PaymentMethodType.klarna)),
        type: PaymentMethodType.klarna
    }
]
